import ProgressDetails from "./ProgressDetails"
import QuizOverview from "./QuizOverview"
import TimeRemaining from "./TimeRemaining"

function QuizDetails({ watchFormValues, onSubmit }) {

    return (
        <div className="col-span-3 lg:px-10 lg:py-10 lg:col-span-1 space-y-7 bg-gray-color-lighter">

            <div className="hidden space-y-7 lg:block">
                <TimeRemaining />

                <ProgressDetails />
            </div>

            <QuizOverview watchFormValues={watchFormValues} onSubmit={onSubmit} />
        </div>
    )
}

export default QuizDetails